import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Routes from "../server/routes";
import OrHeader from "./components/OrHeader/OrHeader";
import OrFooter from "./components/OrFooter/OrFooter";
import AtCookieAlert from "./components/AtCookieAlert/AtCookieAlert";
import OrBannerAppMovil from "./components/OrBannerAppMovil";
import { Fonts, Wp } from "./theme";

import "./index.scss";

const Container = styled(Wp.Container)``;

const CookieAlert = styled(AtCookieAlert)``;
class App extends Component {
  componentDidMount() {
    // NOTE: A hardcoded-placeholder "ViewContent" pixel event used to fire here
    // on every mount (fake shoes/$0 data). Removed — PageView is already tracked
    // in src/index.js. Re-add a per-content ViewContent with real data if needed.

    /*********** CHATBOT (DISABLED — no longer in use, kept for reference) **************/
    // The chatbot is currently disabled. Its config endpoint on the CMS also has
    // no CORS header for the app origin, which produced console errors. Re-enable
    // by uncommenting the loader block below.
    //
    // const scriptlex = document.createElement("script");
    // scriptlex.src =
    //   process.env.PUBLIC_URL + "/scripts/chatbot/lex-web-ui-loader.min.js";
    // scriptlex.async = true;
    // document.body.appendChild(scriptlex);
    //
    // const scriptarrive = document.createElement("script");
    // scriptarrive.src = process.env.PUBLIC_URL + "/scripts/chatbot/arrive.js";
    // scriptarrive.async = true;
    // document.body.appendChild(scriptarrive);
    //
    // setTimeout(function() {
    //   const scriptmain = document.createElement("script");
    //   scriptmain.src =
    //     process.env.PUBLIC_URL + "/scripts/chatbot/chatbot_main.js";
    //   scriptmain.async = true;
    //   document.body.appendChild(scriptmain);
    // }, 1000);
  }

  render() {
    const { location, headerContent, footerContent } = this.props;
    return (
      <Container id="app">
        <OrBannerAppMovil />
        <Fonts.global />
        <OrHeader current={location.pathname} data={headerContent} />
        <Wp.Container id="content">
          <Routes />
        </Wp.Container>
        <OrFooter current={location.pathname} data={footerContent} />
        <CookieAlert />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  user: state.auth.user,
  headerContent: state.content.headerContent,
  footerContent: state.content.footerContent
});

export default withRouter(connect(mapStateToProps)(App));
